export const canUseOnDemandSigning = (organization) =>
  organization?.allowOndemandSigning === true;
